var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReclameAqui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reclame Aqui"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 113",
    cx: 16.8464,
    cy: 16,
    r: 16,
    fill: "#007535"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 14178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6423 18.1026H21.2803L21.416 12.9188L19.6423 18.1026ZM13.9908 22.9893L19.8297 9H24.4713L25.0935 22.9885H21.0796L21.149 20.9285H18.712L18.0154 22.9889L13.9908 22.9893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1889 11.9149L13.5684 15.2484C14.1303 15.2368 14.5637 15.0977 14.8693 14.832C15.1748 14.5667 15.3806 14.1495 15.4868 13.5816C15.5895 13.0254 15.5458 12.6086 15.355 12.3313C15.1645 12.0523 14.8295 11.9145 14.3506 11.9145L14.1889 11.9149ZM8 23L10.603 9.01154H15.346C16.9506 9.01154 18.142 9.39794 18.922 10.1712C19.7017 10.9436 19.9679 11.9941 19.7205 13.3232C19.5686 14.1405 19.2318 14.838 18.7094 15.417C18.1873 15.9946 17.4795 16.4559 16.5869 16.8004L18.3551 22.9996H13.9865L13.1337 17.5856L12.1251 23H8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9316 9.20472C17.9993 8.5483 16.7748 8.26154 15.346 8.26154H10.603H9.97968L9.86565 8.87433L7.26266 22.8628L7.09756 23.75H8H12.1251H12.7483L12.8624 23.1373L13.0718 22.013L13.2126 22.9067L12.8651 23.7394L13.3438 23.7394L13.3454 23.7496H13.9865H18.3551H19.3489L19.0763 22.7939L18.9833 22.4677L19.2501 21.6785H20.3733L20.3301 22.9632L20.304 23.7385H21.0796H25.0935H25.8776L25.8427 22.9551L25.2205 8.96667L25.1887 8.25H24.4713H19.8297H19.33L19.1376 8.71112L18.9316 9.20472ZM14.7494 13.4447C14.7003 13.7066 14.6318 13.8956 14.5578 14.0316L14.7751 12.8642C14.7954 12.9654 14.8046 13.1451 14.7494 13.4447Z",
    stroke: "white",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6423 18.1026H21.2803L21.416 12.9188L19.6423 18.1026ZM13.9908 22.9893L19.8297 9H24.4713L25.0935 22.9885H21.0796L21.149 20.9285H18.712L18.0154 22.9889L13.9908 22.9893Z",
    fill: "#007535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1889 11.9149L13.5684 15.2484C14.1303 15.2368 14.5637 15.0977 14.8693 14.832C15.1748 14.5667 15.3806 14.1495 15.4868 13.5816C15.5895 13.0254 15.5458 12.6086 15.355 12.3313C15.1645 12.0523 14.8295 11.9145 14.3506 11.9145L14.1889 11.9149ZM8 23L10.603 9.01154H15.346C16.9506 9.01154 18.142 9.39794 18.922 10.1712C19.7017 10.9436 19.9679 11.9941 19.7205 13.3232C19.5686 14.1405 19.2318 14.838 18.7094 15.417C18.1873 15.9946 17.4795 16.4559 16.5869 16.8004L18.3551 22.9996H13.9865L13.1337 17.5856L12.1251 23H8Z",
    fill: "#90B823"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReclameAqui);
export default __webpack_public_path__ + "static/media/Reclame-Aqui.28ae4507.svg";
export { ForwardRef as ReactComponent };